import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { AccessProfile } from 'src/app/component/page/company/access-profile/models/access-profile';

@Injectable({ providedIn: 'root' })
@Pipe({
  standalone: true,
  name: 'canAccess'
})
export class CanAccessPipe implements PipeTransform {

  transform(profile: AccessProfile, rule: string | string[], verifyOnlyModule = false): boolean {
    if (!profile || !rule) {
      return true; // by default, allow the access
    }

    if (Array.isArray(rule)) {
      // OR real: libera quando qualquer uma das chaves casar, com a mesma semântica do ramo de
      // string única abaixo (módulo pelo prefixo antes do primeiro ponto, depois `tabs`).
      return rule.some(singleRule => {
        const profilRuleModule = profile.modules.find(m => m.name === singleRule.split('.').shift());

        if (!profilRuleModule) {
          return false;
        }

        if (verifyOnlyModule) {
          return true; // can access the requested module
        }

        return profilRuleModule.tabs && profilRuleModule.tabs.some(t => t === singleRule);
      });
    } else {
      const profilRuleModule = profile.modules.find(m => m.name === rule.split('.').shift());

      if(!profilRuleModule){
        return false;
      }

      if (verifyOnlyModule && profilRuleModule) {
        return true; // can access the requested module
      }

      return profilRuleModule.tabs && profilRuleModule.tabs.some(t => t === rule); // can access the requested inner rule into module
    }
  }

  // ["OS.datails.seeValues", "OS.details.tabs.algumacoisa"]
}
